import { combineReducers } from 'redux'
import payment from './payment'
import search from './search'
import locators from './locators'
import virtualAssistant from './virtualAssistant'
import trackingUserInfo from './trackingUserInfo'
import trackingUserHistory from './trackingUserHistory'
import sharedResources from './sharedResources'
import topicSummary from './topicSummary'

const plugins = combineReducers({
  payment,
  search,
  locators,
  virtualAssistant,
  trackingUserInfo,
  trackingUserHistory,
  sharedResources,
  topicSummary,
})

export default plugins
